/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

 export function  getMaxContentWidth(items: string[]): string {
  let maxWidth = 0;

  // Create a temporary element to measure text width
  const tempElement = document.createElement('div');
  tempElement.style.position = 'absolute';
  tempElement.style.visibility = 'hidden';
  tempElement.style.whiteSpace = 'nowrap';
  document.body.appendChild(tempElement);

  // Iterate through all items and calculate the widest one
  items.forEach(item => {
    tempElement.innerText = item;
    const itemWidth = tempElement.offsetWidth;
    if (itemWidth > maxWidth) {
      maxWidth = itemWidth;
    }
  });

  // Remove the temporary element after calculation
  document.body.removeChild(tempElement);

  // Return the maximum width with some padding
  return (maxWidth + 30).toString(); // Add padding if necessary
}